import { computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import deepClone from '../../foundation/js/deepClone'
import SearchFilteredTags from '../SearchFilteredTags/SearchFilteredTags.vue'
import SpotCardGrid from '../SpotCardGrid/SpotCardGrid.vue'
import ProjectCard from '../ProjectCard/ProjectCard.vue'

export default {
    name: "ProjectsList",
    components: {
        ProjectCard,
        SearchFilteredTags,
        SpotCardGrid
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        firstPageSize: {
            type: Number,
            required: false
        },
        showMorePageSize: {
            type: Number,
            required: false
        },
        hideNoResults: {
            type: Boolean,
            required: false,
            default: false
        },
        hideTotalCount: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    setup(props){

        const store = useStore()

        onMounted(() => {
            initFetchProjects()
        })

        
        const results = computed(() => {
            return deepClone(store.state.search.results[props.guid] ?? [])
        })

        const spotCardCount = computed(() => {
            return results.value.filter(r => r.isSpotCard).length
        })

        const totalCount = computed(() => {
            return store.state.search.scoped_total[props.guid] - spotCardCount.value
        })

        watch(totalCount, (val) => {
            store.commit('search/set_display_total', { guid: props.guid, data: val })
        }, { immediate: true })

        const resultCount = computed(() => {
            return results.value.length - spotCardCount.value
        })

        const tags = computed(() => {
            return store.getters['search/selectedTags'](props.guid) ?? []
        })

        const canShowMore = computed(()=>store.getters['search/canShowMore'](props.guid))

        const showSpinner = computed(
            () => store.state.search.search_inprogress[props.guid]
        )

        const initFetchProjects = function () {
            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.firstPageSize,
                showMorePageSize: props.showMorePageSize,
                url: process.env.PROJECTS_SEARCH
            })

            const inputText = new URLSearchParams(document.location.search).get('q')
            const skip = new URLSearchParams(document.location.search).get('skip')
            const take = new URLSearchParams(document.location.search).get('take') ?? props.firstPageSize

            store.dispatch('search/performZeroSearch', {
                guid: props.guid
            })

            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: inputText,
                skip,
                take
            })

        }

        const getMoreResults = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        return {
            results,
            tags,
            totalCount,
            showSpinner,
            resultCount,
            canShowMore,
            getMoreResults,
            getLabel: (labelKey, params) => store.getters['labels/getLabel']({labelCollection: 'ProjectsList', labelKey, params}),
        }
    }
}